<template>
  <div>
    <v-container fluid>
      <v-layout>
        <v-flex md12>
          <!-- <v-btn :disabled="selected.length===0" @click='onSelectedWorkloadContinue'>Continue</v-btn> -->
          <material-card>
            <v-progress-linear
              v-slot:progress
              v-if="awsAccountListing.loadingWorkloads"
              color="orange"
              indeterminate/>
            <v-data-table
              :headers="awsAccountListing.awsListHeaders"
              :items="filteredWorkloads"
              :pagination.sync="pagination"
              v-model="selected"
              item-key="Project_Id"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td>
                    <v-checkbox
                      v-model="props.selected"
                      color="orange"
                      hide-details
                    />
                  </td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.OppReg_Req_Date }}</td>
                  <!-- <td>{{ props.item.Workload_Status }}</td> -->
                  <td>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }" >
                        <span v-on="on">{{ props.item.Workload_Status }}</span>
                      </template>
                      
                      <span v-if="props.item.Workload_Status ==='Incomplete/Under Review'">Opportunity is not submitted to AWS. Pending further DXC review</span>
                      <span v-else-if="props.item.Workload_Status === 'Submitted to AWS'">Submitted to AWS for validation</span>
                      <!-- <span v-else-if="props.item.Workload_Status === 'Approved - Tier 1 23% - PPA'">Validated by AWS; Returned PPA approval</span>
                      <span v-else-if="props.item.Workload_Status === 'Approved - Tier 3 12%'">Validated by AWS; returned SPP approval</span>
                      <span v-else-if="props.item.Workload_Status === 'Approved - Tier 2 - Custom EDP'">Validated by AWS; Returned EDP approval </span>
                      <span v-else-if="props.item.Workload_Status === 'Disqualified - AWS forecast conflict'">Disqualified by AWS due to a sales/forecast conflict</span>
                      <span v-else-if="props.item.Workload_Status === 'Disqualified - Shareshift' || props.item.Workload_Status === 'Shareshift' ">Disqualified by AWS due to not being PPA or SPP eligible</span>
                      <span v-else-if="props.item.Workload_Status === 'Disqualified - Incomplete'">Disqualified by AWS because DXC has not supplied enough information to determine PPA/SPP eligibility</span>
                      <span v-else-if="props.item.Workload_Status === 'Disqualified - No AWS scope'">Opportunity is completed by user and submitted to DXC for review prior to being submitted to AWS</span> -->
                      <span v-else-if="props.item.Workload_Status === 'Submitted by User'">Opportunity is completed by user and submitted to DXC for review prior to being submitted to AWS</span>
                    </v-tooltip>
                  </td>
                  <td>{{ props.item.Workload_type }}</td>
                </tr>
              </template>
            </v-data-table>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  data () {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {
    ...mapState('user/requestAws', ['awsAccountListing', 'sfdcId', 'selectedWorkload', 'loadingWorkloads', 'awsListHeaders', 'workloads', 'workload']),
    filteredWorkloads () {
      return this.awsAccountListing.workloads
    },
    selected: {
      get () {
        return this.awsAccountListing.selectedWorkload
      },
      set (val) {
        this.setSelectedWorkload(val)
      }
    }
  },
  methods: {
    setSelectedWorkload (workload) {
      let workloadType = workload[0].Workload_type
      if (workloadType === 'DONTKNOW' || workloadType === 'NONDXC' || workloadType === 'NODXCRESALE') {
        this.$store.commit('user/requestAws/setNoDiscountMessage', true)

        this.$store.commit('showDialog', {
          show: true,
          description:  `Workload type cannot be ${workloadType}. Please complete the Update Discount Qualification section in Galaxy Opportunity Registration, left hand column.`,
        }, { root: true })

      } else {
        this.$store.commit('user/requestAws/setSelectedWorkload', workload)
        this.$store.commit('user/requestAws/updateOnboardingProjectId', workload[0].Project_Id)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
